module.exports = __webpack_public_path__ + "static/media/3.89a9d39f.png";